import { useEffect, useReducer } from 'react';
import { getOtpApiAttempts, recordOtpApiAttempts } from '../otpAttempts';

export function useOtpApiAttempts(mobile, operation) {
  const [, refresh] = useReducer((value) => value + 1, 0);
  const record = getOtpApiAttempts(mobile, operation);
  const lockedUntil = record?.lockedUntil || 0;
  const secondsRemaining = Math.max(0, Math.ceil((lockedUntil - Date.now()) / 1000));

  useEffect(() => {
    if (!lockedUntil) return undefined;
    const timer = window.setInterval(refresh, 250);
    return () => window.clearInterval(timer);
  }, [lockedUntil]);

  const recordResponse = (response, requestMobile = mobile) => {
    recordOtpApiAttempts(requestMobile, operation, response);
    refresh();
    return (getOtpApiAttempts(requestMobile, operation)?.lockedUntil || 0) > Date.now();
  };

  return {
    secondsRemaining,
    isLocked: secondsRemaining > 0,
    isLockedNow: () => (getOtpApiAttempts(mobile, operation)?.lockedUntil || 0) > Date.now(),
    message: secondsRemaining > 0 ? record?.message : '',
    attemptsLeft: record?.attemptsLeft ?? null,
    maxAttempts: record?.maxAttempts ?? null,
    recordResponse,
  };
}
